<div class="notifications-container">
  <!-- Header Section -->
  <div class="notifications-header">
    <div class="header-content">
      <div class="header-title">
        <h2 class="title">Notifications</h2>
        <div class="subtitle">Stay updated with your latest activities</div>
      </div>
      <button class="refresh-btn"
              [class.loading]="refreshing"
              (click)="refreshNotifications()"
              [disabled]="refreshing">
        @if (refreshing) {
          <div class="spinner"></div>
        } @else {
          <i class="fa fa-sync-alt"></i>
        }
      </button>
    </div>
  </div>

  <!-- Notifications Content -->
  <div class="notifications-content">
    @if (initialLoading) {
      <!-- Loading Skeleton -->
      <div class="notifications-skeleton">
        <div class="skeleton-item" *ngFor="let item of [1,2,3,4,5]">
          <div class="skeleton-icon"></div>
          <div class="skeleton-content">
            <div class="skeleton-title"></div>
            <div class="skeleton-description"></div>
            <div class="skeleton-time"></div>
          </div>
        </div>
      </div>
    } @else if (items.length === 0) {
      <!-- Empty State -->
      <div class="empty-state">
        <div class="empty-state-content">
          <div class="empty-icon">
            <i class="fa fa-bell-slash"></i>
          </div>
          <h3 class="empty-title">No Notifications</h3>
          <p class="empty-description">
            You're all caught up! New notifications will appear here.
          </p>
          <button class="refresh-empty-btn" (click)="refreshNotifications()">
            <i class="fa fa-sync-alt"></i>
            Check Again
          </button>
        </div>
      </div>
    } @else {
      <!-- Notifications List -->
      <div class="notifications-list">
        <div class="notification-item"
             *ngFor="let notification of items; trackBy: trackByNotification"
             [class.new]="notification.isNew">

          <!-- Notification Icon -->
          <div class="notification-icon"
               [ngClass]="'notification-icon-' + getNotificationColor(notification.type || 'default')">
            <i class="fa" [ngClass]="getNotificationIcon(notification.type || 'default')"></i>
          </div>

          <!-- Notification Content -->
          <div class="notification-content">
            <div class="notification-header">
              <h4 class="notification-title">{{ notification.data.title }}</h4>
              <span class="notification-time">{{ notification.timeAgo }}</span>
            </div>
            <p class="notification-description">{{ notification.data.details }}</p>

            <!-- New Badge -->
            @if (notification.isNew) {
              <span class="new-badge">New</span>
            }
          </div>

          <!-- Action Button -->
          <div class="notification-action">
            <button class="action-btn">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</div>
